import React, { useContext } from "react";
import { Flex, Layout } from "antd";
import {
	HeaderComp,
	ThreeColumnsCards,
	TwoColumnsTextLeft,
	TwoColumnsTextRight,
	CarouselComp,
	FooterComp
} from "../../../components";
import useIsMobile from '../../../utils/isMobile'
import { LangContext } from "../../../utils/LanguageProvider";
const { Header, Content, Footer } = Layout

const RiskManagement = () => {
	const { lang } = useContext(LangContext);
	const isMobile = useIsMobile();
	return (
		<>
			<Header>
				<div className="header-container">
					<HeaderComp />
				</div>
			</Header>
			<div className="full-container">
				<Flex vertical style={{ maxWidth: '1400px', width: '100%' }}>
					<Content className="global-content">
						<TwoColumnsTextLeft page={"risk-management"} section={"twocolumnstextleft"} lang={lang} />
						{!isMobile ? (
							<>
								<ThreeColumnsCards page={"risk-management"} section={"threecolumnscards"} type={'largeCards'} lang={lang} />
							</>
						) : (
							<>
								<CarouselComp page={"risk-management"} section={"threecolumnscards"} type={'largeCards'} buttons={false} lang={lang} />
							</>
						)}
						<TwoColumnsTextRight page={"risk-management"} section={"twocolumnstextright"} lang={lang} />
						<CarouselComp page={"risk-management"} section={"carousell"} type={'smallCard'} lang={lang} />
					</Content>
				</Flex>
			</div>
			<Footer>
				<FooterComp page={'risk-management'} lang={lang} />
			</Footer>
		</>
	);
}

export default RiskManagement